import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 29,
	viewBox: "0 0 28 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9319 3.33301C24.2262 3.33301 24.466 3.57262 24.4661 3.86719V15.291C21.9816 15.0406 20.0452 12.9455 20.0452 10.3945V7.75488H17.3342C14.7831 7.75488 12.688 5.81767 12.4377 3.33301H23.9319Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9761 9.3252C18.2705 9.3252 18.5111 9.56492 18.5112 9.85938V21.2822C16.0264 21.0322 14.0894 18.9379 14.0894 16.3867V13.7461H11.3784C8.82732 13.7461 6.73217 11.8098 6.48193 9.3252H17.9761Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0195 15.3174C12.314 15.3174 12.5546 15.5571 12.5547 15.8516V27.2754C10.0698 27.0254 8.13282 24.9301 8.13281 22.3789V19.7393H5.42188C2.87079 19.7393 0.775622 17.802 0.525391 15.3174H12.0195Z",
			stroke: "currentColor"
		})
	]
});
export default SvgJiraLogoIcon;
